import styled from '@emotion/styled';
import { Button, SpaceDivider, Text } from '@innovationdepartment/proxima-ui';
import LoadingSpinner from 'ui/LoadingSpinner';

type RemoveTagFromBrandConfirmationViewProps = {
  confirm: () => void;
  close: () => void;
  brandName: string;
  tagOriginalName: string;
  isLoading: boolean;
};

const ButtonGroup = styled.div`
  display: inline-flex;
  justify-content: end;
  width: 100%;
  button:first-of-type {
    margin-right: 1rem;
  }
`;

const TextWrapper = styled.div`
  & p {
    font-weight: 400;
  }
`;

const LoadingSpinnerWrapper = styled.div`
  display: block;
  width: 30vw;
  text-align: center;
`;

const RemoveTagFromBrandConfirmationView = ({
  confirm,
  close,
  brandName,
  tagOriginalName,
  isLoading
}: RemoveTagFromBrandConfirmationViewProps) => (
  <TextWrapper>
    {isLoading ? (
      <LoadingSpinnerWrapper>
        <LoadingSpinner size={100} />
      </LoadingSpinnerWrapper>
    ) : (
      <>
        <SpaceDivider y={2} />
        <Text variant="body1">
          Are you sure you want to remove <strong>{tagOriginalName}</strong> from{' '}
          <strong>{brandName}</strong>?
        </Text>
        <SpaceDivider y={6} />
        <ButtonGroup>
          <Button size="small" variant="outlined" label="Cancel" onClick={close} />
          <Button size="small" color="error" label="Remove" onClick={confirm} />
        </ButtonGroup>
      </>
    )}
  </TextWrapper>
);

export default RemoveTagFromBrandConfirmationView;
